@use 'sass:map';
@import '@helsenorge/designsystem-react/scss/breakpoints';
@import '@helsenorge/designsystem-react/scss/spacers';

.content-wrapper {
  margin-top: 2rem;
  width: 100%;

  @media (max-width: map.get($grid-breakpoints, lg)) {
    margin-top: 1.5rem;
  }

  &__grid {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: 1fr;
    justify-content: center;
    gap: 1rem 1.5rem;

    @media (max-width: map.get($grid-breakpoints, md)) {
      row-gap: 0.5rem;
    }
  }

  &--column {
    display: flex;
    justify-content: flex-start;

    @media (max-width: map.get($grid-breakpoints, lg)) {
      display: grid;
      justify-content: center;
    }
  }
}
